<template>
    <div id="title">
    <link href="https://fonts.googleapis.com/css?family=Roboto:300,400&display=swap" rel="stylesheet">
        <h1 id="title-text" ref="titleText">
            <slot></slot>
        <hr :width="this.titleLen*20+'rem'">

        </h1>
    </div>
</template>
<script>
export default {
        data: function () {
        return {
        title: 0,
        titleLen:0
        }
    },
    computed: {
        titleText:{
            get: function () {
            return this.this.title
            },
            // setter
            set: function (newValue) {
            this.title = newValue
            this.titleLen = this.title.split("").length
            }
        }
    },
     mounted() {
         this.titleText = this.$slots.default[0].text
    }
}
</script>
<style scoped>
    #title{
           text-align: center;
           margin-bottom: 0;
            padding: 0px;
            margin: 0px;
    }
    h1{
        font-size: 3rem;
        color: #F0F0F0;
        font-family: 'Roboto', sans-serif;
        font-weight: inherit;

    }
    hr{
        margin: none;
        border-top: none;
        border-color: #F0F0F0;
        max-width: 100%;
    }
</style>